import React from 'react';
import { getPaymentMethods } from '../../api';
import GenericAssigner from './GenericAssigner';

const PaymentMethodAssigner = ({
  order,
  onPaymentMethodChange,
  multiSelect = false,
  selectedOrderIds = [],
  preChargedPaymentMethods
}) => {
  return (
    <GenericAssigner
      order={order}
      onChange={onPaymentMethodChange}
      multiSelect={multiSelect}
      selectedOrderIds={selectedOrderIds}
      preChargedOptions={preChargedPaymentMethods}
      fetchOptions={getPaymentMethods}
      fieldName="paymentMethodId"
      displayField="name"
      valueField="valueId"
    />
  );
};

export default PaymentMethodAssigner;